import { render, staticRenderFns } from "./titlePage.vue?vue&type=template&id=7977093f&scoped=true"
import script from "./titlePage.vue?vue&type=script&lang=js"
export * from "./titlePage.vue?vue&type=script&lang=js"
import style0 from "./titlePage.vue?vue&type=style&index=0&id=7977093f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7977093f",
  null
  
)

export default component.exports